export default "__VITE_ASSET__CNwp4iq6__"